

















































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import VueBase from '@/components/VueBase';
import ListPageBase from '@/components/ListPageBase';
import DataTable from '@/components/Common/DataTable.vue';
import OrderContracts from './OrderContracts.vue';
import { OrderService } from '@/services/OrderService';
import { Order } from '@/models/Orders/Order';
import OrderFilter  from '@/models/Orders/OrderFilter';
import FilterMultiSelect from '@/components/Filter/FilterMultiSelect.vue'
import Option from '@/models/Option';
import ClientOption from '@/models/ClientOption';
import { User } from '@/models/Users/User';
import PageList from '@/models/Pagination/PageList';
import { UnitaryPatentConstants } from '@/constants/UnitaryPatentConstants';
import { Ref, Watch } from 'vue-property-decorator';
import { ClientService } from '@/services/ClientService';
import { EpAttorneyService } from '@/services/EpAttorneyService';
import { CompanyService } from '@/services/CompanyService';
import { TypeOfInstructionService } from '@/services/TypeOfInstructionService';
import { QuestelEntity } from '@/models/Companies/QuestelEntity';
import { TypeOfInstruction } from '@/models/TypeOfInstructions/TypeOfInstruction';
import { OrderStatus } from '../models/Orders/OrderStatus';
import { OrderStatusEnum } from '@/models/Orders/OrderStatusEnum';
import { remove } from 'lodash'
import { Client } from '@/models/Clients/Client';
import FileSaver, { saveAs } from 'file-saver';
import FilterManagerModule from '../modules/FilterManagerModule';
import { getModule } from 'vuex-module-decorators';
import { UserService } from '../services/UserService';
import { OrderContract } from '../models/Orders/OrderContract';
    import { DeclarationOptions } from '../models/Orders/DeclarationOptions';
import { DownloadDocumentOptOut } from '../models/DownloadDocumentOptOut';

@Component({
  components: {
    DataTable,
    FilterMultiSelect,
    OrderContracts
  }
})
export default class Orders extends ListPageBase {
  @Ref('formElement') private readonly formElement: any;
  
    private orderService: OrderService = new OrderService();
    private userService: UserService = new UserService();
  private clientService: ClientService = new ClientService();
  private epAttorneyService: EpAttorneyService = new EpAttorneyService();
  private companyService: CompanyService = new CompanyService();
  private typeOfInstructionService: TypeOfInstructionService = new TypeOfInstructionService();
  private rules: any = { ...UnitaryPatentConstants.validationRules};
  private tableLoading: boolean = false;
  private addOrEditOrder: boolean = false;
    private loadingModule: boolean = false;
    private loadingFile: boolean = false;
    private sendReportModal: boolean = false;
    private downloadOptOutModal: boolean = false;
    private downloadDocumentStatus: DownloadDocumentOptOut = new DownloadDocumentOptOut();
    private declarationTypeError: boolean = false;
    private orderToSend: Order = {};
    private expandRow: boolean = true;
    private sortBy: string = 'OrderNumber_desc';
    private timeout: number = 2000;
    private snackbar: boolean = false;
    private text: string = 'DocuSignId has been copied';
  protected inputOptions = {
    outlined: true,
    dense: true,
    hideDetails: true,
    clearable: true
  };
  private get defaultHeaders(): Array<any> {
    return [
      { 
        text: "Order #",
        value: "OrderNumber",
        align: "start",
        sortable: true,
        width: "7%"
      },
      { 
        text: "Questel Entity",
        value: "QuestelEntityId",
        align: "start",
        sortable: false,
        width: "7%"
      },
      { 
        text: "Client",
        value: "ClientId",
        align: "start",
        sortable: false,
        width: "10%"
      },
      { 
        text: "Client Reference",
        value: "ClientReference",
        align: "start",
        sortable: false,
        width: "10%"
      },
      { 
        text: "EP Attorney",
        value: "EPAttorneyId",
        align: "start",
        sortable: false,
        width: "10%"
      },
      { 
        text: "Status",
        value: "StatusId",
        align: "start",
        sortable: false,
        width: "8%"
        },
        {
            text: "Status Note",
            value: "StatusNote",
            align: "start",
            sortable: true,
            width: "10%"
        },
      { 
        text: "Status Change",
        value: "StatusChange",
        align: "start",
        sortable: true,
        width: "10%"
      },
      { 
        text: "Email",
        value: "Email",
        align: "start",
        sortable: false,
        width: "10%"
      },
        {
            text: "Signed Contracts",
            value: "signedContracts",
            align: "start",
            sortable: false,
            width: "10%"
        },
      
      { 
        text: "Actions",
        value: "Actions",
        align: "center",
        sortable: false,
        width: "10%"
      }
    ]
  }
  private orderFilter: OrderFilter = new OrderFilter();
  private applyFilter: OrderFilter = new OrderFilter();

    private defaultOrder: Order = {
    };

    private declarationConfig: Option[] = [     
    ];

  private clientFilterList: ClientOption[] = [];
  private questelEntitiesFilterList: Option[] = [];
  private clientListSelection: ClientOption[] = [];
  private userList: User[] = [];
  private userFiltered: Option[] = [];
  private epAttorneyFilterList: Option[] = [];
  private questelEntityList: Option[] = [];
  private expanded: Order[] = [];
  private typeOfInstructionList: Option<number>[] = [];
  private orderStatusList: Option[] = [];
  private errorStatus: boolean = false;
  private specialNoteModal: boolean = false;
  private errorMessage: string = "";
  private hover: boolean = false;
  private defaultDeclarationOptionsList: DeclarationOptions[] = [];
  private module: FilterManagerModule = getModule(FilterManagerModule, this.$store);
  private docuSignList: Option[] = [
    {
      text: 'Yes',
      value: true
    },
    {
      text: 'No',
      value: false
    }
  ]

  get formTitle(): string {
    return !this.defaultOrder.Id ? 'Add New' : 'Edit';
    }

    get loaderProgess(): boolean {
        return this.loadingFile;
    }

    async mounted() {
        await this.loadInit();
        this.userList = await this.userService.getUserList();
        this.userFiltered = this.userList.map((item: User) => ({
            text: item.Username,
            value: item.Id
        }));
        this.orderFilter = this.module.orderFilter;

        this.applyFilter = this.module.orderFilter;
        this.onPageChanged(1);
    }


  async loadData(): Promise<void> {
    var clientResultList = await this.clientService.getClientFilter();
    this.clientListSelection = clientResultList.map(item => ({
      value: item.Value,
      text: item.Text + " - " + item.Email,
      email: item.Email,
        questelEntityId: item.QuestelEntityId,
        DeclararationId: item.DeclarationId
    }));
    this.clientFilterList = [...this.clientListSelection];
    
    var epAttyFilterListResult = await this.epAttorneyService.getEpAttorneyList();
    this.epAttorneyFilterList = epAttyFilterListResult.map(item => ({
      value: item.Id,
      text: `${item.Firstname} ${item.Lastname}`
    }));

      var declarationsOptionsList = await this.orderService.getDeclarationOptions();
      console.log(declarationsOptionsList);
      this.defaultDeclarationOptionsList = declarationsOptionsList;

      var tempList = declarationsOptionsList.filter(element => element.TypeOfInstructionId == 1);
      this.declarationConfig = tempList.map(item => ({
          value: item.Id,
          text: `${item.Name}`,
      }))

    var questelEntityListResult = await this.companyService.getQuestelEntityList();
    this.questelEntityList = questelEntityListResult.map((item: QuestelEntity) => ({
      text: item.QuestelEntityName,
      value: item.QuestelEntityId
    }));
    this.questelEntitiesFilterList = [...this.questelEntityList];

    var typeOfInstructionListResult = await this.typeOfInstructionService.getTypeOfInstructionList();
    this.typeOfInstructionList = typeOfInstructionListResult.map((item: TypeOfInstruction) => ({
      text: item.Name,
      value: item.Id
    }));

    var orderStatuses = await this.orderService.getOrderStatuses();
    this.orderStatusList = orderStatuses.map((item: OrderStatus) => ({
      text: item.Name,
      value: item.Id
    }));

      this.resetDefaultOrder();
      this.sortBy = 'OrderNumber_desc';
  }

  updatePageData(): void {
    this.$nextTick(() => {
      this.tableLoading = true;
    });

    this.orderService.getOrders({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      orderBy: this.sortBy
    }, this.applyFilter)
    .then(success => {
        this.pagedData = success;
        this.pagedData.Data.forEach((element: Order) => {

            if (element.DeclarationOptionsDTO != null && element.DeclarationOptionsDTO.isMultipleContract) {
                var contract: OrderContract = {};
                contract.Id = element.Id;
                contract.Email = element.Email;
                contract.StatusId = element.StatusId;
                contract.StatusNote = element.StatusNote;

                var index = this.clientListSelection.findIndex(client => client.value == element.ClientId);
                contract.CompanyName = this.clientListSelection[index].text;
                element.Contracts.unshift(contract);
            }
        });
    })
    .finally(() => {
      this.tableLoading = false;
    });
    }

    private onSendContract(item: Order): void {
        if (item.DeclarationOptionsDTO != null && item.DeclarationOptionsDTO.SendContract) {
            this.updateStatus(item, OrderStatusEnum.ToSign);
        }
        else {
            this.updateStatus(item, OrderStatusEnum.NoSignature);
        }
    }

    private onCopyValue(item: Order): void {
        const textField = document.createElement('textarea');
        textField.innerText = item.DocuSignId;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        document.body.removeChild(textField);
        this.snackbar = true;
    }

    private filterDeclarationTypes(TypeId: number): void {
        const newOptionsArray = this.defaultDeclarationOptionsList.filter(element => element.TypeOfInstructionId == TypeId);

        this.declarationConfig = newOptionsArray.map(item => ({
            value: item.Id,
            text: `${item.Name}`,
        }));
    }

    private checkDocumentOnClient(clientId: Guid): boolean {
        let index = this.clientFilterList.findIndex(element => element.value == clientId);

        if (index >= 0) {
            if (this.clientFilterList[index].DeclararationId != null)
                return true;
            else
                return false;
        }
        else {
            return false;
        }
    }

    private displayQuestelEntity(id: number): any {
        let index = this.questelEntityList.findIndex(y => y.value == id);
        let text = "";

        if (index >= 0) {
            text = this.questelEntityList[index].text;
        }

        return text;
    }

    private displayStatus(id: number): any {
        let index = this.orderStatusList.findIndex(y => y.value == id);
        let text = "";

        if (index >= 0) {
            text = this.orderStatusList[index].text;
        }

        return text;
    }

    private displayCustomer(id: number): any {
        let index = this.clientListSelection.findIndex(y => y.value == id);
        let text = "";

        if (index >= 0) {
            let name = this.clientListSelection[index].text;
            let splitted = name.split("-");
            text = splitted[0];
        }

        return text;
    }

    private displayEPAttorney(id: number): any {
        let index = this.epAttorneyFilterList.findIndex(y => y.value == id);
        let text = "";

        if (index >= 0) {
            text = this.epAttorneyFilterList[index].text;
        }

        return text;
    }

    private displayComment(order: Order): string {
        if (order.Comment == null) {
            return "No comment available";
        }
        else {
            return order.Comment;
        }
    }

    private isCommentAvailable(order: Order): boolean {
        if (order.Comment == null || order.Comment == "") {
            return false;
        }
        else {
            return true;
        }
    }

    private displayEditWarning(order: Order): boolean {
        if (order.DeclarationOptionsDTO == null || order.DeclarationOptionsDTO.SendContract == null) {
            if (order.StatusId == OrderStatusEnum.Created) {
                return true;
            }
            else if (order.StatusId == OrderStatusEnum.Uploaded) {
                return true;
            }
            else if (order.StatusId == OrderStatusEnum.Cancelled) {
                return false;
            }
            else if (order.StatusId == OrderStatusEnum.Failed) {
                return false;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

  private onRowEdit(item: Order): void {
      this.defaultOrder = { ...item };
    this.questelEntitiesFilterList = [...this.questelEntityList.filter(q => q.value === this.defaultOrder.QuestelEntityId)];
    this.clientFilterList = [...this.clientListSelection.filter(c => c.questelEntityId == this.defaultOrder.QuestelEntityId)];
      this.addOrEditOrder = true;

      if (this.defaultOrder.DeclarationOptionsDTO != null && this.defaultOrder.DeclarationOptionsDTO.SendContract == null) {
          this.declarationTypeError = true;
      }
      else {
          this.declarationTypeError = false;
      }
    }

    private defineDisabledContract(item: Order): boolean {
        if (item.DeclarationOptionsDTO != null && item.DeclarationOptionsDTO.SendContract == null) {
            return true;
        }
        else {
            return false;
        }
    }

  private updateStatus(item: Order,status: OrderStatusEnum) {
      this.orderService.updateOrderStatus({
          OrderID: item.Id,
          OrderStatus: status,
          SendCsv: true,
          SpecialNote: item.SpecialNote
      })
          .then(success => {
              this.$nextTick(() => { item.StatusId = status; });
          }).catch(ex => {
              this.errorStatus = true;
              this.errorMessage = ex.Message;
          });
  }

    private onLodge(item: Order): void {
        this.updateStatus(item, OrderStatusEnum.ToLodge);
    }

    private onDigitalSign(item: Order): void {
        this.updateStatus(item, OrderStatusEnum.DigitalSignature);
    }

    private onReadyLodge(item: Order): void {
        this.updateStatus(item, OrderStatusEnum.ReadyToLodge);
    }

    private openSendReport(item: Order): void {
        this.orderToSend = item;
        this.specialNoteModal = true;
    }

    private onSendReport(item: Order): void {
        this.updateStatus(item, OrderStatusEnum.ToReport);
        this.specialNoteModal = false;
    }
    private viewReport(item: Order): void {
        this.loadingModule = true;
        this.loadingFile = true;
        this.orderService.getReport(item.Id)
            .then(success => {
                var filename = '';
                var disposition = success.headers.get('Content-Disposition');
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
                success.blob().then((b: any) => {
                    FileSaver.saveAs(b, decodeURIComponent(filename));
                });
            })
            .catch(error => {
                this.loadingModule = false;
                this.loadingFile = false;
            }).finally(() => {
                this.loadingModule = false;
                this.loadingFile = false;
            });
    }

  private onRowCancel(item: Order): void {
    this.updateStatus(item, OrderStatusEnum.Cancelled);
    }

    private onRowRetry(item: Order): void {
        this.orderService.retryOrder(item).then(success => {
            this.$nextTick(() => {
                this.onPageSizeChanged(20);
            });
        });
    }

    private DownloadDocuments(item: Order): void {
        this.orderService.downloadOptOutDocuments(item.Id).then(success => {
            console.log(success);
            this.downloadOptOutModal = true;
            this.downloadDocumentStatus.OrderId = item.Id;
            this.downloadDocumentStatus.isArchived = success.isArchived;
            this.downloadDocumentStatus.URLToDownload = success.URLToDownload;
            console.log(this.downloadDocumentStatus);
        });
    }

    private onRowContract(item: Order): void {
        this.loadingModule = true;
        this.loadingFile = true;

        if (item.DeclarationOptionsDTO != null && item.DeclarationOptionsDTO.isMultipleContract) {
            this.orderService.getAllOrderContract(item.Id)
                .then(success => {
                    var filename = '';
                    var disposition = success.headers.get('Content-Disposition');
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                    success.blob().then((b: any) => {
                        FileSaver.saveAs(b, decodeURIComponent(filename));
                    });
                })
                .catch(error => {
                    this.loadingModule = false;
                    this.loadingFile = false;
                }).finally(() => {
                    this.loadingModule = false;
                    this.loadingFile = false;
                });
        }
        else {
            this.orderService.getOrderContract(item.Id)
                .then(success => {
                    var filename = '';
                    var disposition = success.headers.get('Content-Disposition');
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                    success.blob().then((b: any) => {
                        FileSaver.saveAs(b, decodeURIComponent(filename));
                    });
                })
                .catch(error => {
                    this.loadingModule = false;
                    this.loadingFile = false;
                }).finally(() => {
                    this.loadingModule = false;
                    this.loadingFile = false;
                });
        }
        
  }

  onPageChanged(pNumber: number): void {
    this.pageNumber = pNumber;
    this.updatePageData();
  }

  onPageSizeChanged(pSize: number): void {
    this.pageSize = pSize;
    this.updatePageData();
  }

  private applyFilters(): void {
      //this.applyFilter = {...this.orderFilter};

      this.module.setFilter(this.orderFilter);
      this.applyFilter = this.module.orderFilter;
      this.onPageChanged(1);
  }
  
    private onSaveOrder(): void {
        this.defaultOrder.Comment = "";
    if (!this.formElement.validate()) {
      return;
    }

      if (!this.defaultOrder.Id) {
      this.orderService.addOrder(this.defaultOrder)
      .then(success => {
        if(success.Success) {
          this.addOrEditOrder = false;
          this.$router.push({name: 'orderDetails', params: { order_id: success.Data.Id}});
        }
      })
      .catch(err => { 
        this.displayError();
      });
    }
    else {
      this.orderService.updateOrder(this.defaultOrder)
      .then(success => {
        if(success.Success) {
          this.pagedData.Data.filter(d => d.Id === this.defaultOrder.Id).forEach(item => {
              Object.assign(item, {... this.defaultOrder});
            });
          this.addOrEditOrder = false;
        }
      })
      .catch(err => { 
        this.displayError(); 
      });
    }
  }

  private onCancel(): void {
      this.addOrEditOrder = false;
      this.declarationTypeError = false;
    }

    private onCancelSend(): void {
        this.specialNoteModal = false;
        this.orderToSend = {};
    }

    private onResetDocument(): void {
        var orderId : Guid = this.downloadDocumentStatus.OrderId
        this.orderService.resetDownloadOptOutDocuments(orderId);
        this.downloadOptOutModal = false;
        this.downloadDocumentStatus.isArchived = false;
        this.downloadDocumentStatus.URLToDownload = '';
    }

  private onAddOrder(): void {
    this.addOrEditOrder = true;
  }

  @Watch('addOrEditOrder')
  onDialogValueChanged(newVal: boolean): void {
    if (!newVal) {
      this.resetAll();
    }
  }

  private onRowClicked(item: Order): void {
    this.$router.push({name: 'orderDetails', params: { order_id: item.Id}});
  }

  private onClientSelectedChanged(value: Guid) {
    if(value) {
      var qEntity = this.clientFilterList.find(c => c.value === value).questelEntityId;
      this.defaultOrder.Email = this.clientListSelection.find(x => x.value == value).email;

      if(!this.defaultOrder.QuestelEntityId) {
        this.defaultOrder.QuestelEntityId = qEntity;
        this.clientFilterList = [...this.clientListSelection.filter(c => c.questelEntityId == qEntity)]
      }
    }
    else {
      this.defaultOrder.Email = undefined;
    }

    this.questelEntitiesFilterList = this.defaultOrder.QuestelEntityId && value ? 
                                      [...this.questelEntityList.filter(q => q.value === this.defaultOrder.QuestelEntityId)] :
                                      [...this.questelEntityList];
  }

  private onQuestelEntityChanged(id: Guid | undefined): void {
    if(id) {
      this.clientFilterList = [...this.clientListSelection.filter(c => c.questelEntityId == id)];
      if(this.defaultOrder.ClientId && this.clientListSelection.findIndex(c => c.value === this.defaultOrder.ClientId) == -1) {
        this.defaultOrder.ClientId = undefined;
        this.defaultOrder.Email = undefined;
      }
    }
    else {
      this.clientFilterList = [...this.clientListSelection];
    }

    if(!this.defaultOrder.ClientId) {
      this.questelEntitiesFilterList = [...this.questelEntityList];
    }
    
  }

  private resetDefaultOrder(): void {
    var onlyValidOption = this.typeOfInstructionList.length ? this.typeOfInstructionList[0].value : undefined;
      this.defaultOrder = {
        TypeId : onlyValidOption
      };
  }
  private resetAll(): void {
    this.clientFilterList = [...this.clientListSelection];
    this.questelEntitiesFilterList = [...this.questelEntityList];
    this.resetDefaultOrder();
    this.formElement.resetValidation();
  }

    private resetFilters(): void {
        let filter = this.module.orderFilter;
        if (filter.ClientReference ||
            filter.QuestelEntityIds.length > 0 ||
            filter.EPAttorneyIds.length > 0 ||
            filter.StatusIds.length > 0 ||
            filter.ClientIds.length > 0 ||
            filter.DocuSign != undefined ||
            filter.TypeIds.length > 0 ||
            filter.UserIds.length > 0 ||
            filter.OrderNumber
        ) {
            this.orderFilter = new OrderFilter();
            this.module.resetFilter();
            this.applyFilter = {...this.orderFilter};
            this.$nextTick(() => {
            this.updatePageData();
      })
    }
  }

    private onSortChanged(sortChange: string): void {
    this.sortBy = sortChange;
    this.updatePageData();
  }

  private canSendReport(order: Order): boolean {
    return [OrderStatusEnum.Lodge].includes(order.StatusId);
    }

    private canDownloadOptOut(order: Order): boolean {
        return [OrderStatusEnum.ToReport, OrderStatusEnum.ReadyToLodge, OrderStatusEnum.Lodge, OrderStatusEnum.LodgeRequested, OrderStatusEnum.Completed, OrderStatusEnum.Cancelled, OrderStatusEnum.Failed].includes(order.StatusId);
    }

    private canViewReport(order: Order): boolean {
        return [OrderStatusEnum.Lodge, OrderStatusEnum.ToReport, OrderStatusEnum.Completed, OrderStatusEnum.Cancelled, OrderStatusEnum.Failed, OrderStatusEnum.LodgeRequested].includes(order.StatusId);
    }

    private canSendContract(order: Order): boolean {
        if (order.DeclarationOptionsId != null && order.isVerified)
            return [OrderStatusEnum.Uploaded].includes(order.StatusId);
        else
            return false;
    }

    private canCopyDocuSign(order: Order): boolean {
        if (order.DocuSignId != null && order.DocuSignId != '') {
            return true;
        }
        else {
            return false;
        }
    }

    private canShowContract(order: Order): boolean {
        if (order.DeclarationOptionsDTO != null && order.DeclarationOptionsDTO.SendContract) {
            return [OrderStatusEnum.ToLodge, OrderStatusEnum.Signed, OrderStatusEnum.Completed, OrderStatusEnum.Failed, OrderStatusEnum.LodgeRequested, OrderStatusEnum.ToLodge, OrderStatusEnum.ReadyToLodge, OrderStatusEnum.DigitalSignature, OrderStatusEnum.Cancelled].includes(order.StatusId);
        }
        else {
            return false;
        }
  }

  private canEdit(order: Order): boolean {
    return [OrderStatusEnum.Uploaded, OrderStatusEnum.Created].includes(order.StatusId);
  }

    private canLodge(order: Order): boolean {
        return [OrderStatusEnum.ReadyToLodge].includes(order.StatusId);
    }

    private canDigitalSign(order: Order): boolean {
        return [OrderStatusEnum.Signed, OrderStatusEnum.NoSignature].includes(order.StatusId);
    }

    private canReadyLodge(order: Order): boolean {
        return [OrderStatusEnum.DigitalSignature].includes(order.StatusId);
    }

    private canCancel(order: Order): boolean {
        return [OrderStatusEnum.Created, OrderStatusEnum.Uploaded, OrderStatusEnum.ToSign, OrderStatusEnum.Signed, OrderStatusEnum.NoSignature, OrderStatusEnum.DigitalSignature, OrderStatusEnum.ReadyToLodge, OrderStatusEnum.Lodge, OrderStatusEnum.ToLodge].includes(order.StatusId);
    }

    private canRetry(order: Order): boolean {
        if (order.isVerified == false && order.DocuSignId == null && (order.StatusId == OrderStatusEnum.Failed)) {
            return true;
        }
        else {
            return false;
        }
    }

  private setStatusColor(id: OrderStatusEnum): string {
    var result = '--black-color';
    switch(id) {
      case OrderStatusEnum.Created : 
            result = '--order-created'
            break;
      case OrderStatusEnum.Uploaded :
            result = '--order-uploaded'
            break;
        case OrderStatusEnum.NoSignature:
            result = '--order-nosignature'
            break;
      case OrderStatusEnum.ToSign :
            result = '--order-tosign'
            break;
      case OrderStatusEnum.Signed :
            result = '--order-signed'
            break;
      case OrderStatusEnum.Lodge :
            result = '--order-lodged'
            break;
      case OrderStatusEnum.Completed :
            result = '--order-completed'
            break;
      case OrderStatusEnum.ToLodge :
            result = '--order-lodged'
            break;   
      case OrderStatusEnum.ToReport :
            result = '--order-completed'
            break; 
      case OrderStatusEnum.Cancelled :
            result = '--order-cancelled'
            break;   
      case OrderStatusEnum.Failed :
            result = '--order-failed'
            break;
        case OrderStatusEnum.DigitalSignature:
            result = '--order-digital'
            break;
        case OrderStatusEnum.ReadyToLodge:
            result = '--order-readyToLodge'
            break;
        case OrderStatusEnum.LodgeRequested:
            result = '--order-lodgeRequested'
            break;
    }

    return result;
  }
}
